import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  AvatarGroup,
  Chip,
  IconButton,
  Paper,
  Divider,
  Tab,
  Tabs,
  Popover,
  TextField as MuiTextField,
  Autocomplete,
  Menu,
  MenuItem,
  Tooltip,
  Skeleton,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ApartmentIcon from '@mui/icons-material/Apartment';
import GroupIcon from "@mui/icons-material/Group";
import EditIcon from "@mui/icons-material/Edit";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import moment from "moment";
import { checkPrivileges, handleDownloadOrPreview } from "../../Helpers";
import Button from "../common/Button";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ConfirmDialoag from "../common/ConfirmDialoag";
import { useSelector } from "react-redux";
import PriorityHighIcon from '@mui/icons-material/Flag';
import instance from "../../axios";
import DownloadIcon from "@mui/icons-material/Download";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ActivityList from "./ActivityList";
import { toast } from "react-toastify";
import AttachmentsList from "./AttachmentsList";
const isImage = (file) => {
  return /\.(jpg|jpeg|png|gif|webp)$/i.test(file);
};
const getAllAttachments = (ticket, comments) => {
  const ticketFile = ticket?.file
    ? [{ id: `ticket-${ticket.id}`, file: ticket.file }]
    : [];

  const commentFiles = (comments || [])
    .filter((c) => c.file && c.file.trim() !== "")
    .map((c) => ({
      id: c.id,
      file: c.file,
    }));

  return [...ticketFile, ...commentFiles];
};
const getFileName = (file) => file.split("/").pop();
const TaskView = ({
  task,
  onClose,
  translate,
  handleEdit,
  ticketAssignToUser,
  createTicketComment,
  ticketComments,
  deleteTicketComment,
  updateTicketComment,
  ticketActivity,
  isloadingComments
}) => {

  const loginUser = useSelector((state) => state.logInUsers)
  const [activeTab, setActiveTab] = useState(0);
  const [commentText, setCommentText] = useState("");
  const [replyCommentId, setReplyCommentId] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [commentFile, setCommentFile] = useState("")
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuCommentId, setMenuCommentId] = useState(null);
  const [editCommentId, setEditCommentId] = useState(null);
  const [editText, setEditText] = useState("");
  const [replyFile, setReplyFile] = useState(null);
  const [isDeleteComment, setIsDeleteComment] = useState(false)
  const [deleteComment, setDeleteComment] = useState(null)

  const fileInputRef = React.useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      alert("File size must be less than 5MB");
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      const base64 = event.target.result.split("base64,")[1];

      const obj = {
        name: file.name,
        contentType: file.type,
        entity: "comment",
        entityId: task?.id,
        data: base64,
      };

      setCommentFile(obj); // replaces previous file
    };

    reader.readAsDataURL(file);
  };
  const removeFile = () => {
    setCommentFile(null);
  };
  const handleReplyFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      alert("File size must be less than 5MB");
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      const base64 = event.target.result.split("base64,")[1];

      const obj = {
        name: file.name,
        contentType: file.type,
        entity: "comment",
        entityId: task?.id,
        data: base64,
      };

      setReplyFile(obj);
    };

    reader.readAsDataURL(file);
  };

  const handleSendReply = async (commentId) => {
    if (!replyText.trim() && !replyFile) return;

    try {
      let fileUrl = "";

      if (replyFile) {
        try {
          const uploadRes = await instance.post("/api/uploads", replyFile, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          });

          fileUrl = uploadRes?.url || "";
        } catch (uploadError) {
          toast.error("File upload failed" + uploadError?.message);

          return;
        }
      }

      const payload = {
        ticketId: task.id,
        ticketCommentId: commentId,
        description: replyText,
        file: fileUrl,
        created: new Date(),
      };

      await createTicketComment(payload);
      setReplyText("");
      setReplyFile(null);
      setReplyCommentId(null);

    } catch (error) {
      toast.error("Failed to send reply");
    }
  };


  const handleSendComment = async () => {
    if (!commentText.trim() && !commentFile) return;

    try {
      let fileUrl = "";

      if (commentFile) {
        try {
          const uploadRes = await instance.post("/api/uploads", commentFile, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          });

          fileUrl = uploadRes?.url || "";
        } catch (uploadError) {
          toast.error("File upload failed" + uploadError?.message);

          return;
        }
      }
      const payload = {
        ticketId: task.id,
        ticketCommentId: null,
        description: commentText,
        file: fileUrl,
        created: new Date(),
      };
      await createTicketComment(payload);
      setCommentFile(null);
      setCommentText("");

    } catch (error) {
      toast.error("Failed to send comment");
    }
  };






  const handleMenuOpen = (event, commentId) => {
    setAnchorEl(event.currentTarget);
    setMenuCommentId(commentId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuCommentId(null);
  };

  const handleSaveEdit = (id) => {
    const newReply = {
      ...editCommentId,
      description: editText,
      id,

    }
    updateTicketComment(newReply)
    setEditCommentId(null);
    setEditText("");
  };


  const handleDeleteComment = (comment) => {
    setDeleteComment(comment)
    setIsDeleteComment(true)
  }
  const removeComment = () => {
    if (!deleteComment?.id) return
    deleteTicketComment(deleteComment.id)
    setIsDeleteComment(false)
    setDeleteComment(null)
  }

  const closeDeleteModal = () => {
    setIsDeleteComment(false)
    setDeleteComment(null)
  }

  const renderComments = (parentId = 0, level = 0) => {
    return ticketComments?.data
      ?.filter((c) => c.ticketCommentId === parentId)
      ?.sort((a, b) => new Date(a.created) - new Date(b.created))
      .map((c) => {
        const isEditing = editCommentId?.id === c.id;
        return (
          <Box key={c.id} sx={{ display: "flex", gap: 1.5, mb: 1, ml: level * 2 }}>
            <Avatar
              sx={{
                width: level === 0 ? 36 : 28,
                height: level === 0 ? 36 : 28,
                bgcolor: "#6cc04a",
                fontSize: level === 0 ? "0.8rem" : "0.7rem",
              }}
            >
              {c.attributes?.userName?.[0]?.toUpperCase() || "U"}
            </Avatar>
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 0.5, position: "relative" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "space-between" }}>
                <Typography fontWeight="bold" variant={level === 0 ? "body1" : "body2"}>
                  {c.attributes?.userName || "User"}
                </Typography>
                <IconButton size="small" onClick={(e) => handleMenuOpen(e, c.id)}>
                  <MoreVertIcon fontSize="small" />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={menuCommentId === c.id}
                  onClose={handleMenuClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  {checkPrivileges("ticketcommentUpdate")&&
                  <MenuItem onClick={() => { setEditCommentId(c); setEditText(c.description); handleMenuClose(); }}>
                    Edit
                  </MenuItem>
                  }
                  {checkPrivileges("ticketcommentDelete")&&
                  <MenuItem onClick={() => { handleDeleteComment(c); handleMenuClose(); }}>
                    Delete
                  </MenuItem>
                  }
                </Menu>
              </Box>

              <Typography variant="caption" color="text.secondary">
                {moment(c.created).format(level === 0 ? "MMMM D, YYYY [at] HH:mm" : "MMM D, YYYY HH:mm")}
              </Typography>
              <Paper
                elevation={0}
                sx={{
                  mt: 0.5,
                  p: level === 0 ? 1.5 : 1,
                  borderRadius: 1,
                  border: "1px solid #ddd",
                  backgroundColor: level === 0 ? "#fff" : "#f0f2f5",
                }}
              >
                {isEditing ? (
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <MuiTextField
                      fullWidth
                      size="small"
                      value={editText}
                      onChange={(e) => setEditText(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && handleSaveEdit(c.id)}
                    />
                    <Button variant="contained" size="small" onClick={() => handleSaveEdit(c.id)}>
                      Save
                    </Button>
                    <Button variant="outlined" size="small" onClick={() => setEditCommentId(null)}>
                      Cancel
                    </Button>
                  </Box>
                ) : (
                  <Box>
                    <Typography variant="body2">{c.description}</Typography>

                    {c.file && (
                      <Box sx={{ mt: 1 }}>
                        {isImage(c.file) ? (
                          <Box
                            sx={{
                              position: "relative",
                              width: 200,
                              borderRadius: 2,
                              overflow: "hidden",
                              cursor: "pointer"
                            }}
                          >
                            <img
                              src={c.file}
                              alt="attachment"
                              style={{ width: "100%", display: "block" }}
                              onClick={() => window.open(c.file, "_blank")}
                            />
                            <IconButton
                              size="small"
                              sx={{
                                position: "absolute",
                                top: 5,
                                right: 5,
                                backgroundColor: "rgba(0,0,0,0.5)",
                                color: "#fff",
                                "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" }
                              }}
                              onClick={(e) => {
                                e.stopPropagation();

                                fetch(c.file)
                                  .then((res) => res.blob())
                                  .then((blob) => {
                                    const url = window.URL.createObjectURL(blob);

                                    const link = document.createElement("a");
                                    link.href = url;
                                    link.download = getFileName(c.file);
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);

                                    window.URL.revokeObjectURL(url);
                                  })
                                  .catch(() => {
                                    window.open(c.file, "_blank");
                                  });
                              }}
                            >
                              <DownloadIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              p: 1,
                              border: "1px solid #ddd",
                              borderRadius: 2,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              maxWidth: 300,
                              backgroundColor: "#f5f5f5"
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <InsertDriveFileIcon />
                              <Typography variant="caption">
                                {getFileName(c.file)}
                              </Typography>
                            </Box>

                            <IconButton
                              size="small"
                              onClick={() => {
                                const link = document.createElement("a");
                                link.href = c.file;
                                link.download = getFileName(c.file);
                                link.click();
                              }}
                            >
                              <DownloadIcon fontSize="small" />

                            </IconButton>
                          </Box>
                        )}
                      </Box>
                    )}
                  </Box>
                )}
              </Paper>
              
              <Typography
                variant="body2"
                sx={{ cursor: "pointer", mt: 0.5, color: "#555" }}
                onClick={() => setReplyCommentId(c.id)}
              >
                Reply
              </Typography>
              {replyCommentId === c.id&&checkPrivileges("ticketcommentCreate") && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                  <Avatar sx={{ width: 28, height: 28, bgcolor: "#6cc04a", fontSize: "0.7rem" }}>
                    {loginUser.name?.[0]?.toUpperCase() || "U"}
                  </Avatar>

                  <MuiTextField
                    fullWidth
                    size="small"
                    placeholder="Write a reply..."
                    value={replyText}
                    onChange={(e) => setReplyText(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSendReply(c.id)}
                    InputProps={{
                      startAdornment: replyFile && (
                        <Chip
                          label={replyFile.name}
                          size="small"
                          onDelete={() => setReplyFile(null)}
                          sx={{ mr: 0.5 }}
                        />
                      ),
                      endAdornment: (
                        <IconButton component="label" size="small">
                          <AttachFileIcon fontSize="small" />
                          <input
                            type="file"
                            hidden
                            onChange={handleReplyFileChange}
                          />
                        </IconButton>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        fontSize: "0.85rem",
                      },
                    }}
                  />

                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleSendReply(c.id)}
                    sx={{
                      backgroundColor: "#6cc04a",
                      "&:hover": { backgroundColor: "#5aab3a" },
                    }}
                  >
                    Send
                  </Button>
                </Box>
              )}

              {renderComments(c.id, level + 1)}
            </Box>
          </Box>
        );
      });
  };

  const attachments = useMemo(() => {
    return getAllAttachments(task, ticketComments?.data || []);
  }, [task, ticketComments?.data]);

  const tabs = [
  ...(checkPrivileges("ticketcomment")
    ? [{ label: `Comment ${ticketComments?.data?.length || 0}`, key: "comment" }]
    : []),
  { label: "Activity", key: "activity" },
  { label: "Attachment", key: "attachment" },
];
  if (!task) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box
        mb={3}
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          backgroundColor: "#F1F8EC",
          borderRadius: 2,
          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          {translate("taskView")}
        </Typography>

        <Button
          onClick={onClose}
          variant="contained"
          color="secondary"
          sx={{ textTransform: "none", px: 3 }}
        >
          {translate("back")}
        </Button>
      </Box>
      <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
        <Box
          sx={{
            width: 420,
            flexShrink: 0,
            flexGrow: 0,
            backgroundColor: "#F1F8EC",
            borderRadius: 2,
            p: 2,
          }}
        >
          <Paper
            elevation={0}
            sx={{ minHeight: 400, backgroundColor: "#F1F8EC !important" }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                mb: 3,
              }}
            >
              <Typography variant="h5" fontWeight="bold">
                {task.name}
              </Typography>
              <IconButton
                size="small"
                sx={{ backgroundColor: "#6cc04a", color: "#fff" }}
                onClick={() => handleEdit(task)}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                gap: 2,
                mb: 3,
              }}
            >
              {/* Row 1 */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CalendarTodayIcon sx={{ fontSize: 16 }} />
                <Typography variant="body2" fontWeight={600}>
                  {translate ? translate("deadline") : "Deadline"}:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                >
                  {task.dueDate ? moment(task.dueDate).format("ddd, DD MMM YYYY") : "-"}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PriorityHighIcon sx={{ fontSize: 16 }} />
                <Typography variant="body2" fontWeight={600}>
                  {translate ? translate("priority") : "Priority"}:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                >
                  {task.priority || "-"}
                </Typography>
              </Box>

              {/* Row 2 */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <ApartmentIcon sx={{ fontSize: 16 }} />
                <Typography variant="body2" fontWeight={600}>
                  {translate ? translate("department") : "Department"}:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                >
                  {task.department || "-"}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <GroupIcon sx={{ fontSize: 16 }} />
                <Typography variant="body2" fontWeight={600}>
                  Assigned:
                </Typography>

                {task?.attributes?.assignTo && (
                  <Tooltip title={task.attributes.assignTo}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        px: 1.5,
                        py: 0.25,
                        bgcolor: "#e6f4ea",
                        borderRadius: 999, // pill shape
                        boxShadow: "0px 1px 4px rgba(0,0,0,0.1)",
                        cursor: "default",
                        maxWidth: 200,
                        overflow: "hidden",
                      }}
                    >
                      <Avatar
                        sx={{
                          width: 28,
                          height: 28,
                          bgcolor: "#6cc04a",
                          fontSize: "0.85rem",
                          border: "2px solid #fff",
                        }}
                      >
                        {task.attributes.assignTo[0].toUpperCase()}
                      </Avatar>
                      <Typography
                        variant="body2"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {task.attributes.assignTo}
                      </Typography>
                    </Box>
                  </Tooltip>
                )}
              </Box>
            </Box>

            <Box mb={2}>
              <Typography variant="h6" fontWeight="bold" mb={1}>
                {translate ? translate("description") : "Description"}
              </Typography>
              <Typography variant="body2" sx={{ lineHeight: 1.7 }}>
                {task.description || "-"}
              </Typography>
            </Box>
            {task.file && (
              <Box>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<AttachFileIcon />}
                  onClick={() => handleDownloadOrPreview(task.file)}
                  sx={{ color: "#6cc04a", borderColor: "#6cc04a" }}
                >
                  {typeof task.file === "string"
                    ? decodeURIComponent(task.file.split("/").pop())
                    : task.file?.name || "View File"}
                </Button>
              </Box>
            )}
          </Paper>
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Paper
            elevation={0}
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              overflow: "hidden",
              minHeight: 400,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Tabs */}
     <Tabs
  value={activeTab}
  onChange={(_, v) => setActiveTab(v)}
  sx={{
    borderBottom: "1px solid #e0e0e0",
    "& .MuiTab-root": {
      fontSize: "0.8rem",
      textTransform: "none",
      fontWeight: 600,
    },
    "& .Mui-selected": { color: "#6cc04a !important" },
    "& .MuiTabs-indicator": { backgroundColor: "#6cc04a" },
  }}
>
  {tabs.map((tab) => (
    <Tab key={tab.key} label={tab.label} />
  ))}
</Tabs>

            {/* Tab Content */}
            <Box sx={{ flex: 1, overflowY: "auto", p: 2, maxHeight: 540 }}>
              {tabs[activeTab]?.key === "comment"&&checkPrivileges("ticketcomment") && (
                <Box>

      {isloadingComments ? (
  <Box>
    {[1,2,3].map((item) => (
      <Box key={item} sx={{ display: "flex", gap: 1.5, mb: 2 }}>
        <Skeleton variant="circular" width={36} height={36} />
        <Box sx={{ flex: 1 }}>
          <Skeleton width="30%" />
          <Skeleton width="80%" />
          <Skeleton width="60%" />
        </Box>
      </Box>
    ))}
  </Box>
) : ticketComments?.data?.length > 0 ? (
  renderComments(0, 0)
) : (
  <Typography variant="body2" color="text.secondary">
    No comments yet
  </Typography>
)}
                </Box>
              )}

              {tabs[activeTab]?.key === "activity" &&
                (ticketActivity?.length > 0 ? (
                  <ActivityList activity={ticketActivity} />
                ) : (
                  <Typography sx={{ textAlign: "center", py: 2 }}>
                    No Activity Found 🕒
                  </Typography>
                ))}

              {tabs[activeTab]?.key === "attachment" &&
                (attachments?.length > 0 ? (
                  <AttachmentsList
                    attachments={attachments}
                    onFileClick={(url) => handleDownloadOrPreview(url)}
                  />
                ) : (
                  <Typography sx={{ textAlign: "center", py: 2 }}>
                    No Attachments 📎
                  </Typography>
                ))}
            </Box>
            {tabs[activeTab]?.key === "comment"&&checkPrivileges("ticketcommentCreate") && (
              <Box
                sx={{
                  borderTop: "1px solid #e0e0e0",
                  p: 1.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Avatar
                  sx={{
                    width: 32,
                    height: 32,
                    bgcolor: "#6cc04a",
                    fontSize: "0.75rem",
                  }}
                >
                  {loginUser.name?.[0]?.toUpperCase() || "U"}

                </Avatar>
                <>
                  <MuiTextField
                    fullWidth
                    size="small"
                    placeholder="Write a comment"
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSendComment()}
                    InputProps={{
                      startAdornment: commentFile && (
                        <Chip
                          label={commentFile.name}
                          size="small"
                          onDelete={removeFile}
                          sx={{ mr: 0.5 }}
                        />
                      ),
                      endAdornment: (
                        <IconButton size="small" onClick={() => fileInputRef.current.click()}>
                          <AttachFileIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        fontSize: "0.85rem",
                        display: "flex",
                        alignItems: "center"
                      }
                    }}
                  />

                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleSendComment}
                  sx={{
                    backgroundColor: "#6cc04a",
                    "&:hover": { backgroundColor: "#5aab3a" },
                    minWidth: "fit-content",
                    px: 2,
                    borderRadius: 2,
                  }}
                >
                  Send
                </Button>
              </Box>
            )}
          </Paper>
        </Box>
      </Box>

      {isDeleteComment && (
        <ConfirmDialoag
          onCancel={closeDeleteModal}
          onOk={removeComment}
          title={translate("areYouWantToDelete")}
        >
          {deleteComment?.description}
        </ConfirmDialoag>
      )}
    </Box>
  );
};

export default TaskView;
